/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerNotificationResponse as ModelsCustomerCustomerNotificationResponse } from '../../models/Models/Customer/customer-notification-response';

export interface V3CustomersMeNotificationsNotificationIdGet$Json$Params {
  notificationId: string;
}

export function v3CustomersMeNotificationsNotificationIdGet$Json(http: HttpClient, rootUrl: string, params: V3CustomersMeNotificationsNotificationIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerNotificationResponse>> {
  const rb = new RequestBuilder(rootUrl, v3CustomersMeNotificationsNotificationIdGet$Json.PATH, 'get');
  if (params) {
    rb.path('notificationId', params.notificationId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsCustomerCustomerNotificationResponse>;
    })
  );
}

v3CustomersMeNotificationsNotificationIdGet$Json.PATH = '/v3/customers/me/notifications/{notificationId}';
